import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DEFAULT_SETTINGS } from "config.js";

export const BREAKPOINTS = { sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1400 };

const useMenuStore = create(
  persist(
    (set) => ({
      behaviour: DEFAULT_SETTINGS.MENU_BEHAVIOUR,
      placement: DEFAULT_SETTINGS.MENU_PLACEMENT,
      useSidebar: DEFAULT_SETTINGS.USE_SIDEBAR,
      pinButtonEnable: true,
      placementStatus: {},
      behaviourStatus: {},
      navClasses: {},
      attrMobile: false,
      attrMenuAnimate: "",
      collapseAll: false,
      breakpoints: {
        verticalUnpinned: BREAKPOINTS.xxl,
        verticalMobile: BREAKPOINTS.lg,
        horizontalMobile: BREAKPOINTS.lg,
      },
      menuPadding: 0,
      menuChangePlacement: (placement) => set({ placement }),
      menuChangePlacementStatus: (placementStatus) => set({ placementStatus }),
      menuChangeBehaviour: (behaviour) => set({ behaviour }),
      menuChangeBehaviourStatus: (behaviourStatus) => set({ behaviourStatus }),
      menuChangePinButtonEnable: (pinButtonEnable) => set({ pinButtonEnable }),
      menuChangeAttrMenuAnimate: (attrMenuAnimate) => set({ attrMenuAnimate }),
      menuChangeAttrMobile: (attrMobile) => set({ attrMobile }),
      menuChangeCollapseAll: (collapseAll) => set({ collapseAll }),
      menuChangeNavClasses: (navClasses) => set({ navClasses }),
      menuChangeBreakpoints: (breakpoints) =>
        set((state) => ({
          breakpoints: { ...state.breakpoints, ...breakpoints },
        })),
      menuResetBreakpoints: () =>
        set({
          breakpoints: {
            verticalUnpinned: BREAKPOINTS.xxl,
            verticalMobile: BREAKPOINTS.lg,
            horizontalMobile: BREAKPOINTS.lg,
          },
        }),
      menuChangeUseSidebar: (useSidebar) => set({ useSidebar }),
      menuResetUseSidebar: () =>
        set({ useSidebar: DEFAULT_SETTINGS.USE_SIDEBAR }),
      menuChangeMenuPadding: (menuPadding) => set({ menuPadding }),
    }),
    {
      name: "menu-storage",
    }
  )
);

export default useMenuStore;
